import React, { useEffect, useState } from "react";
import ESPieChart from "../../controls/ESPieChart";
import { getPollResponse } from "../../utils/ApiUrl";
import { axiosPost } from "../../utils/AxiosHelper";
import { showToast, ToastTypeCode } from "../../utils/Constant";
import Loader from "../loader/Loader";
import { Col, ProgressBar, Row } from "react-bootstrap";
import "./PollResult.scss";
import liveico from "./../../assets/images/live.svg";

type PollResultProps = {
  setPollResultView: React.Dispatch<React.SetStateAction<boolean>>;
  surveysAssignmentId?: number;
  surveyFormId: number;
};

interface PollStatisticAssestmentInfo {
  Title: string;
  Count: number;
  Percentage: number;
  OptionValue: string;
}

interface PollStatistics {
  TotalRespondents: number;
  TotalResponse: number;
  PollStatisticAssestmentInfoList: PollStatisticAssestmentInfo[]
}

const PollResult: React.FC<PollResultProps> = ({
  setPollResultView,
  surveysAssignmentId,
  surveyFormId
}) => {
  const [loading, setLoading] = useState(false);
  const [pollStatistics, setPollStatistics] = useState<PollStatistics>();

  const handleButtonClick = () => {
    setPollResultView(false);
  };

  useEffect(() => {
    fetchPollLiveResult();
    const interval = setInterval(() => {
      fetchPollLiveResult();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchPollLiveResult = async () => {
    const payload = {
      SurveyAssignmentId: surveysAssignmentId,
      SurveyFormId: surveyFormId
    };
    setLoading(true);
    try {
      const response: any = await axiosPost(getPollResponse, payload);
      if (response?.data?.Status !== 200) {
        showToast(response?.data?.ErrorMessage, ToastTypeCode?.ERROR);
      } else {
        const rawData = response?.data?.ExtraData;
        const transformedData: PollStatistics = {
          TotalRespondents: rawData[0]?.TotalFormResponses || 0,
          TotalResponse: rawData[0]?.TotalResponses || 0,
          PollStatisticAssestmentInfoList: rawData?.map((item: PollStatisticAssestmentInfo) => ({
            Title: item?.OptionValue,
            Count: item?.Count,
            Percentage: item?.Percentage,
          })),
        };
        setPollStatistics(transformedData);
      }
    } catch (error) {
      showToast("Error submitting the Form", ToastTypeCode?.ERROR);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="poll-result-wrapper">
          <Row>            
            <Col>
            <div className="my-3">
            {pollStatistics?.PollStatisticAssestmentInfoList?.map(
            (response: PollStatisticAssestmentInfo, index: number) => (
              <div className="mb-3" key={index} >
                <div className="d-flex justify-content-between">
                  <div>{response?.Title}</div>
                  <div>Count: {response?.Count}</div>
                </div>
                <div>{response?.Percentage.toFixed(2)}%</div>
                <ProgressBar striped variant="success" now={response?.Percentage}  className="pg-block"/>
              </div>
            )
          )}
          </div>
            </Col>
            <Col>
            <div className="my-3">
            {pollStatistics?.PollStatisticAssestmentInfoList &&  pollStatistics?.TotalRespondents>0 ? (
            <ESPieChart
              data={
                pollStatistics?.PollStatisticAssestmentInfoList?.map(
                  (response: PollStatisticAssestmentInfo) => ({
                    Title: response?.Title,
                    Count: response?.Percentage,
                  })
                )
              }
              title="Poll Result"
            />
          ) : (
            <div className="alert alert-warning">No data to show for Poll</div>
          )}
          </div>

            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <div className="div-repondent d-flex justify-content-between text-start" >
                <p>Total Respondents : {pollStatistics?.TotalRespondents}</p>
                <p>Total Response  : {pollStatistics?.TotalResponse}</p>                
              </div>
              <div className="d-flex flex-row">
                <div className="alert alert-success p-2">  
                  <img src={liveico} className="me-2" alt="" width="16" height="14" />
                   Live Result
                </div>
                <button onClick={handleButtonClick} className="btn btn-primary-outline">
                  Back to Poll
                </button>
                </div>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};


export default PollResult;
